module.exports = __webpack_public_path__ + "img/yuanwei3.fd74ab76.png";